<div class="site-text">
    <p class="text">
        eDirectory.ch is part of the activities of swissDIGIN and is operated by PostFinance Ltd. The technical operation is conducted by xeFex AG on behalf of PostFinance Ltd.
    </p>
    <p class="title">
        swissDIGIN
    </p>
    <p class="text">
        The swissDIGIN (swiss Digital Invoice) initiative is advancing the electronic exchange of invoices between companies and organizations (e-invoicing for short) in Switzerland. To this end, swissDIGIN provides companies with expertise from a neutral source.
        <br>
        <a href="https://www.swissdigin.ch" target="_blank">www.swissdigin.ch</a>
    </p>
    <p class="title">
        PostFinance Ltd
    </p>
    <p class="text">
        As the Swiss market leader in e-invoicing, PostFinance has been digitizing the provision and receipt of invoices for its customers for over 20 years.
        PostFinance is an e-invoicing service provider, an eBill network partner and an eBill-affiliated bank all rolled into one. With the PostFinance solution, companies and organizations can exchange e-bills with business partners as well as send and receive eBills, enabling them to organize their processes efficiently. Business customers benefit from comprehensive advice and have a contact person at their disposal who covers all concerns relating to e-invoicing.
        <br>
        <a href="https://www.postfinance.ch/billing-solutions" target="_blank">www.postfinance.ch/billing-solutions</a>
    </p>
    <p class="title">
        xeFex AG
    </p>
    <p class="text">
        xeFex AG provides IT services in the areas of programming, consulting and project management.
        <br>
        <a href="https://www.xefex.ch" target="_blank">www.xefex.ch</a>
    </p>
    <p class="title">
        E-billing service providers
    </p>
    <p class="text">
        The following e-billing service providers list the invoice issuers and invoice recipients who are connected to their network and interested in making greater use of e-invoicing with eDirectory.ch.
    </p>
    <a class="logo" href="https://www.postfinance.ch/billing-solutions" target="_blank"><img src="/assets/images/post_finance.png" alt="postfinance logo"></a>
    <a class="logo" href="https://www.abacus.ch" target="_blank"><img src="/assets/images/abacus_full.png" alt="abacus logo"></a>
    <p class="text">
        If you are an e-invoicing service provider offering e-billing services to companies and organizations domiciled in Switzerland and would like to publish your customers on eDirectory, please indicate your interest by contacting PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. We will get back to you as soon as possible.
    </p>
</div>
